<template>
  <div @click="openPopup()">
    <vs-popup class="integration--item-popup" :title="data.title" :active.sync="detailsPopupActive">
      <div>
        <div class="flex items-start">
          <span class="template-options-btn-icon p-4 inline-flex feather-icon text-primary mr-3 icon-style">
            <img :src="data.icon" width="28px" height="28px" />
          </span>
          <div class="relative m-1">
            <div class="flex">
              <h4 class="mb-1">
                {{ data.title }}
              </h4>
              <div v-if="activeIntegrations.includes(data.id)" class="ml-2 right-panel--item-skill">
                ◉ Active
              </div>
            </div>
            <p>{{ data.shortDescription }}</p>
          </div>
        </div>
        <vs-divider />
        <div class="flex flex-col">
          <p v-html="data.description"></p>
          <div v-if="data.id === 'hibob'">
            <h3 class="pt-4">App Configurations</h3>
            <div class="vx-row py-4">
              <div class="vx-col w-full lg:w-1/2">
                <vs-row>
                  <label>HiBob Api Key</label>
                  <vs-input class="w-full pt-1" v-model="localHibobConfig.apiKey" />
                </vs-row>
              </div>
            </div>
            <vs-button color="primary" class="ml-auto" :disabled="!localHibobConfig.apiKey"
              @click.stop="saveHibobConfigs()">Save</vs-button>
          </div>
          <vs-button v-else @click="configureIntegration()" class="mt-4 self-end">
            Configure
          </vs-button>
        </div>
      </div>
    </vs-popup>
    <!-- <vs-popup class="integration--item-popup" :title="data.title" :active.sync="iframePopupActive"> -->
    <!-- <div>
        <iframe :src="magicLink" width="100%" height="500px" frameborder="0"></iframe>
      </div> -->
    <!-- </vs-popup> -->
    <vx-card class="org-card integration--item-card overflow-hidden">
      <div class="integration--item">
        <div class="pl-3 vx-row flex justify-start flex-wrap">
          <span class="p-2 inline-flex mr-3 icon-style">
            <img :src="data.icon" width="40px" height="40px" />
          </span>
          <div class="vs-col">
            <div class="flex">
              <p class="info-heading">
                {{ data.title }}
              </p>
              <div v-if="activeIntegrations.includes(data.id)" class="ml-2 right-panel--item-skill">
                ◉ Active
              </div>
            </div>
            <p>{{ data.shortDescription }}</p>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      magicLink: "",
      detailsPopupActive: false,
      iframePopupActive: false,
      localHibobConfig: JSON.parse(
        JSON.stringify(
          this.orgData &&
            this.orgData.appConfigs &&
            this.orgData.appConfigs.hibob
            ? this.orgData.appConfigs.hibob
            : {}
        )
      ),
    };
  },
  props: ["data"],
  methods: {
    onSuccess(token) {
      console.log(token);
    },
    openPopup() {
      this.detailsPopupActive = true;
    },
    openIframe() {
      this.iframePopupActive = true;
    },
    configureIntegration() {
      const payload = {
        integration: this.data.id,
        email: this.userData.email,
        gtbrddOrganizationId: this.orgData._id,
        gtbrddOrganizationName: this.orgData.name,
        categories: this.data.categories,
      };
      this.$vs.loading();
      this.$store
        .dispatch("integrtions/createIntegrationLink", payload)
        .then((res) => {
          console.log(res.data)
          // this.magicLink = res.data.magicLink;
          // this.openIframe();
          window.open(res.data.magicLink);
        })
        .finally(() => {
          this.detailsPopupActive = false;
          this.$vs.loading.close();
        });
    },
    saveHibobConfigs() {
      try {
        if (this.orgData.appConfigs) {
          this.$store
            .dispatch("organization/saveHibobConfig", {
              organizationId: this.orgData._id,
              "appConfigs.hibob": this.localHibobConfig,
            })
            .then(() => {
              this.$vs.notify({
                title: "Hibob Configs Saved Successfully",
              });
            });
        } else {
          this.$store
            .dispatch("organization/saveHibobConfig", {
              organizationId: this.orgData._id,
              appConfigs: {
                hibob: this.localHibobConfig,
              },
            })
            .then(() => {
              this.$vs.notify({
                title: "Hibob Configs Saved Successfully",
              });
            });
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  computed: {
    organizationId() {
      return this.$route.params.organizationId;
    },
    activeIntegrations() {
      if (this.$store.state.integrtions.activeIntegrations !== undefined) {
        return this.$store.state.integrtions.activeIntegrations;
      }
      return [];
    },
    userData() {
      return this.$store.state.users.data;
    },
    orgData() {
      return this.$store.state.organization.orgData;
    },
  },
  watch: {
    orgData() {
      this.localHibobConfig = JSON.parse(
        JSON.stringify(
          this.orgData &&
            this.orgData.appConfigs &&
            this.orgData.appConfigs.hibob
            ? this.orgData.appConfigs.hibob
            : {}
        )
      );
      this.$store.dispatch(
        "integrtions/fetchActiveIntegration",
        this.orgData._id
      );
    },
  },
  created() {
    if (this.orgData) {
      this.localHibobConfig = JSON.parse(
        JSON.stringify(
          this.orgData &&
            this.orgData.appConfigs &&
            this.orgData.appConfigs.hibob
            ? this.orgData.appConfigs.hibob
            : {}
        )
      );
      this.$store.dispatch(
        "integrtions/fetchActiveIntegration",
        this.orgData._id
      );
    }
  },
};
</script>

<style scoped>
.right-panel--item-skill {
  background: rgba(68, 204, 136, 0.1);
  border-radius: 1000px;
  color: #44cc88;
  padding: 1px 8px;
  line-height: 2;
  float: left;
  font-size: 12px;
}

.info-heading {
  font-weight: 600 !important;
}

.icon-style {
  border-radius: 6px;
  border-style: solid;
  border-color: rgba(128, 128, 128, 0.164);
  border-width: 1px;
}

.integration--item {
  box-sizing: border-box;
  border-radius: 6px;
}

.integration--item-card {
  transition: ease-in-out 0.3s;
}

.integration--item-popup>>>.vs-popup {
  width: 950px;
}

.integration--item-card:hover {
  background: #fffdf7 !important;
  box-shadow: 0px 8px 40px rgba(242, 194, 68, 0.05);
  transform: scale(1.03);
}
</style>
